<template>
  <div>
    <br />
    <b-container>
      <div class="alert alert-danger">
        <p>
          <b>Usted no se encuentra incorporado en el Registro Electoral.</b>
          Para ingresar una solicitud de incorporación presione el botón
          “Solicitud de incorporación” para que se revise su caso con los
          organismos pertinentes.
        </p>
        <p><b>Considere que:</b></p>
        <ul style="list-style-type: circle">
          <li style="display: list-item">
            Si es chileno nacido en el extranjero, se consultará a la Policía de
            Investigaciones (PDI) sobre el cumplimiento del requisito de
            avecindamiento de <b>1 año en Chile.</b>
          </li>
          <li style="display: list-item">
            Si es extranjero, se consultará al Servicio de Migraciones para
            verificar el cumplimiento del requisito de avecindamiento de
            <b
              >10 años en Chile luego de obtenido el permiso de residencia
              definitivo</b
            >
            (el requisito cambió a 10 años de producto de la Ley N°21.773, que
            modifica la Carta Fundamental en Materia de Derecho a Sufragio de
            Personas Extranjeras, la que fue publicada el 7 de octubre de 2025 y
            rige desde el año 2026)”.
          </li>
          <!-- <li style="display: list-item">
            Si se cumplen los requisitos establecidos será incorporado con el
            domicilio electoral indicado en el siguiente formulario. En el caso
            de extranjeros, solo podrá indicar un domicilio dentro del
            territorio nacional.
          </li> -->
        </ul>
        <!-- <p>
          <b
            >Importante: Si la solicitud de incorporación se registra desde el
            29 de junio de 2025 a las 00:01 horas en adelante, esta será
            procesada a partir del 1 de diciembre de 2025 en caso de que no haya
            segunda vuelta, o bien desde el 1 de enero de 2026 si sí hay segunda
            vuelta en la elección presidencial. Esto significa que no se verá
            reflejada para las elecciones del año 2025.</b
          >
        </p> -->
        <br />
      </div>
      <b-row style="display: flex; justify-content: space-between">
        <b-col lg="6" sm="12">
          <b-button
            @click="ir()"
            variant="gobierno"
            title="Continuar a la solicitud de cambio de domicilio"
            style="width: 100%"
            class="mt-2"
          >
            Solicitud de Incorporación
          </b-button></b-col
        ><b-col lg="6" sm="12">
          <b-button
            @click="salir()"
            variant="outline-gobierno"
            title="Salir"
            style="width: 100%"
            class="mt-2"
          >
            Salir
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import auth from "./../app/auth";
export default {
  name: "Redirect",
  data: function () {
    return {};
  },
  methods: {
    async ir() {
      window.location = "/incorporacion";
    },
    async salir() {
      await auth.logoutClaveUnica();
    },
  },
  mounted() {},
};
</script>
